module.exports = __webpack_public_path__ + "img/IMG_2493_L_WoodMatted.43394828.jpg";